import {MtplQuotation} from "../model/quotation";
import { EngineType } from "../model/vehicle";
import { strings } from "../strings/strings";

export const needToShowCascoAdditionalFields = (quotation: MtplQuotation) => {
    if (quotation.cascoAdditionalCoverage?.covered === true) {
        if (quotation.mtplContract.vehicle.vehicleType !== "E"
            && quotation.mtplContract.vehicle.vehicleType !== "F") {
            return true;
        }
    }

    return false;
};

export const isSmartDrive = (tarrificationProgram: string) => {
    return tarrificationProgram === 'mtpl_online_00001_smart_drive';
}

export const formatVehicleEngineType = (engineType: EngineType) => {
    switch (engineType) {
        case EngineType.DIESEL: return strings.engineTypeLbl.diesel;
        case EngineType.GASOLINE: return strings.engineTypeLbl.gasoline;
        case EngineType.ELECTRIC: return strings.engineTypeLbl.electric;
        case EngineType.HYBRID: return strings.engineTypeLbl.hybrid;
        case EngineType.LPG: return strings.engineTypeLbl.lpg;
    }
}

